import type { SelectedPlaybook } from "@repo/app-types/agents/selectedPlaybook";
import type { FC } from "react";

export const SelectedPlaybookSection: FC<{
  playbook: SelectedPlaybook | undefined;
}> = ({ playbook }) => {
  if (!playbook) {
    return null;
  }
  return (
    <section className="space-y-2">
      <div className="text-[10px] font-semibold text-gray-400">Playbook</div>
      <div className="inline-block max-w-full rounded-md bg-gray-100 px-2 py-1 text-xs text-gray-700">
        {playbook.name}
      </div>
    </section>
  );
};
